import type { MeetingPrepMessagePart } from "@acto/genui-components-schema";
import type { MeetingPrepStoryRemoval } from "@acto/taskpane/core/domain";

/**
 * Headline of the first story card not masked by an active removal. Cards
 * without a storyKey cannot be removed and are always visible.
 */
export function firstVisibleStoryHeadline(
  parts: MeetingPrepMessagePart[],
  removals: MeetingPrepStoryRemoval[] | undefined,
): string | undefined {
  const removedStoryKeys = new Set(removals?.map((removal) => removal.storyKey));
  return parts
    .filter((part) => part.type === "storyCard")
    .find((card) => !(card.storyKey && removedStoryKeys.has(card.storyKey)))?.storyHeadline;
}
